import { TRANSLATE_FIELD_QUERY } from "@app/shared-core/general/translate/queries/translate-field.query";

export const TYPE_COST_TYPE_QUERY = `
  id
  name {${TRANSLATE_FIELD_QUERY}}
`;
